const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermostatDanfoss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 244.8 245.4",
    style: {
      enableBackground: "new 0 0 244.8 245.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FEFCFF;}\r\n\t.st1{fill:#FEFCFF;stroke:#DDDBDE;stroke-miterlimit:10;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{opacity:0.57;fill:url(#SVGID_3_);}\r\n\t.st5{opacity:0.57;fill:url(#SVGID_4_);}\r\n\t.st6{opacity:0.57;fill:url(#SVGID_5_);}\r\n\t.st7{opacity:0.49;fill:url(#SVGID_6_);}\r\n\t.st8{fill:#979392;}\r\n"), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.7,231.7H7.3c-1.3,0-2.4-1.1-2.4-2.4V6.9c0-1.3,1.1-2.4,2.4-2.4h222.3c1.3,0,2.4,1.1,2.4,2.4v222.3 C232.1,230.6,231,231.7,229.7,231.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 408,
    height: 409,
    xlinkHref: "1132ADBF.png",
    transform: "matrix(0.6 0 0 0.6 0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.3,205.2H42.8c-6.1,0-11-4.9-11-11V42.8c0-6.1,4.9-11,11-11h150.4c6.1,0,11,4.9,11,11v151.3 C204.3,200.2,199.3,205.2,193.3,205.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.4,179.5h-110c-3.8,0-6.8-3.1-6.8-6.8V63.3c0-3.8,3.1-6.8,6.8-6.8h110c3.8,0,6.8,3.1,6.8,6.8v109.3 C180.2,176.4,177.1,179.5,173.4,179.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.7673,
    y1: 170.7317,
    x2: 176.4427,
    y2: 170.7317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1A1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.4,162c36,0,72,0,108,0c1.3,5.6,2.7,11.2,4,16.8c-0.3,0.2-0.7,0.3-1.2,0.5c-1.1,0.3-2.1,0.3-2.3,0.3 c-2.1-0.1-108.9,0-109.6,0c-0.4,0-1,0-1.7-0.2c-0.4-0.1-0.7-0.2-1-0.3C62,173.3,63.2,167.6,64.4,162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.5581,
    y1: 179.5118,
    x2: 118.5581,
    y2: 161.9583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.4,162c36,0,72,0,108,0c1.3,5.6,2.6,11.2,3.9,16.9c-0.3,0.2-0.7,0.3-1.2,0.5c-1.1,0.3-1.9,0.2-2.1,0.2 c-2.4-0.1-108.9,0-109.6,0c-0.4,0-1,0-1.7-0.2c-0.4-0.1-0.7-0.2-1-0.3C62,173.3,63.2,167.6,64.4,162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.388,
    y1: 74.0365,
    x2: 118.388,
    y2: 56.4999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.4,74c36,0,72,0,107.9,0c2.4-4.6,4.7-9.2,7.1-13.7c-1-1.3-2.4-2.7-4.4-3.4c-0.9-0.3-1.7-0.4-2.1-0.4 c-36.5,0-73.1,0-109.6,0c-0.1,0-0.3,0-0.5,0c0,0-0.6,0-1.1,0.2c-1.4,0.4-2.6,1.3-2.6,1.3c-1,0.8-1.6,1.7-1.9,2.3 C59.7,64.9,62.1,69.4,64.4,74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.5833,
    y1: 119.623,
    x2: 64.4167,
    y2: 119.623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M64.4,162V74l-7.1-13.8c-0.2,0.3-0.4,0.7-0.5,1.2c-0.2,0.6-0.2,1.1-0.2,1.5c0,36.5,0,73.1,0,109.6 c0,0.6,0.1,2.6,1.5,4.3c0.9,1.1,2,1.7,2.6,2C62,173.3,63.2,167.6,64.4,162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.3695,
    y1: 119.8061,
    x2: 180.2028,
    y2: 119.8061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M172.4,162l0-87.9l7.1-13.8c0.2,0.3,0.4,0.7,0.5,1.2c0.2,0.6,0.2,1.1,0.2,1.5c0,36.5,0,73.1,0,109.6 c0,0.8-0.2,2.7-1.5,4.3c-1.1,1.4-2.7,2-3.8,2.3C174,173.5,173.2,167.8,172.4,162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.7673,
    y1: 170.6302,
    x2: 64.9583,
    y2: 170.6302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    style: {
      stopColor: "#ACABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "60.8,179 64.4,162 65,162 61.8,179.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.5,187.7c2.9-1.1,6.2-1.8,9.5-1.3l0.3-0.6c0.7-0.1,1.4-0.2,2.1-0.3l-0.9,1.4c0.9,0.4,1.7,1.3,1.7,2.4 c0,1.4-0.6,2.5-1.3,3.5l1-0.1c0.7-1.1,2.6-2.4,3.4-1.4l0.3-0.4c0,0,1.2-0.2,1.3-0.2c-1.1,2.1-1.7,2.6-1.6,2.8c0.2,0.2,2.2-1.6,3-3 l1.2-0.1l-0.7,1.2c1.2-1,1.7-1.6,2.3-1.4c0.9,0.4-1.1,2.6-0.9,2.7c0.2,0.1,1.9-1.1,2.6-2.3l-1.1,0.2l0.4-0.7l1.1-0.1 c1.2-2.2,4.4-6.5,5.4-5.9c0.9,0.6-1.3,3.4-4.1,5.5l-0.2,0.3l2.5-0.3c0,0,0.1,0.1,0,0.2c-0.8,0.7-2.4,2.3-1.5,2.9 c0.7,0.3,1.9-1.4,2-1.8c-0.6-0.2-0.1-2,0.8-1.8c0.6,0.2,0.2,1.1,0,1.4c1.2-0.1,2.2-1.4,2.2-1.4c0-1,0.6-2,1.3-1.7 c0.5,0.2,0.1,0.9-0.7,1.7c-0.1,0.1-0.1,0.5-0.1,0.9c0.8-0.3,1.7-0.7,2.5-1c0-0.9,0.5-2,1.2-1.8c0.6,0.2,0,1.3-0.7,1.9 c0,1.2,0.2,2-0.1,2.7c-0.4,0.7-1.6,1.4-2.3,0.9c-0.8-0.4-0.1-1.4,0.4-1.8c0.4-0.3,1.5-0.8,1.5-0.8s0.1-0.4,0-0.6 c-0.4,0.3-2.4,1-2.4,1c-0.1,0.7-0.1,1-0.4,1.7c-0.4,0.8-1.8,1.2-2.3,0.7c-0.3-0.3-0.2-1.1,0.5-1.6c0.5-0.4,1.6-0.9,1.6-0.9 s0.1-0.4,0.1-0.6c-0.7,0.6-1.5,1.2-2.5,1.2l0,0c-0.6,1.2-2.3,3-3.5,2.2c-1.1-0.7,0.7-2.7,0.9-2.8c-0.4,0-1.1,0.2-1.1,0.2l-2,3.7l0,0 c0,0,6.9-0.8,13.1-0.8l-0.7,0.7c0.4,0.3,0.7,0.5,1.1,0.7c0,0-6.5-0.3-14,0.3l-1.1,2l-1.4,0.1l1.2-2c0,0-3.4,0.1-10.9,1.1 c0.1-0.2,0.1-0.2,0.2-0.4c6.7-1.3,11.2-1.6,11.2-1.6s1-1.8,1-1.8c-0.7,0.5-2.1,1.7-2.7,1.1c-0.4-0.6,1.1-2.3,0.9-2.4 c-0.1-0.1-2,1.8-2.6,2.8c-0.4,0-1.1,0.1-1.1,0.1l0.5-1c-0.6,0.5-1.2,1-1.9,1.2c-0.2,0.1-0.6,0.1-0.8-0.4c0,0-1.3,1.2-2.3,0.7 c-0.5-0.3-0.3-1.2-0.2-1.4l-1.1,0.1c-4.7,5.4-10.7,6-11.4,4.8c-0.8-1.3,2-3,5.7-4.1c0,0,3.3-6,3.3-6.1c-4.6-0.7-10.3,2.9-10.3,2.9 L156.5,187.7z M158.3,197.4c0.5,0.7,5.1,0,8.2-3.8c-2.1,0.3-3.4,0.8-3.8,1c-1,1.6-1.4,2.2-1.8,2.2c-0.5-0.1,0.3-0.9,0.7-1.8 C159.8,195.5,157.8,196.8,158.3,197.4z M163.2,193.7c1.2-0.3,3-0.6,3.7-0.7c0.5-0.9,2.3-3.8-0.2-4.7L163.2,193.7z M170.4,192.5 c-0.4,0.5-0.7,1.3-0.4,1.5c0.3,0.2,1.1-0.5,1.4-0.8c0.5-0.6,0.8-1.4,0.6-1.6C171.4,191.3,170.6,192.1,170.4,192.5z M182.1,188.5 c0.9-0.6,3.2-2.9,2.6-3.4C184.1,184.8,182.6,187.4,182.1,188.5z M186.2,191.2c-0.4,0.3-0.6,0.6-0.4,0.8c0.2,0.1,0.7-0.1,0.9-0.4 c0.3-0.5,0.4-0.8,0.4-0.8S186.8,190.8,186.2,191.2z M189.2,191c-0.1,0.1-0.6,0.6-0.4,0.8c0.2,0.2,0.7-0.1,0.9-0.4 c0.3-0.3,0.4-0.9,0.4-0.9S189.6,190.7,189.2,191z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermostatDanfoss);
export default __webpack_public_path__ + "static/media/termostat_danfoss.33058164960387293b305d2c952e96f2.svg";
export { ForwardRef as ReactComponent };